import { useQuery } from '@tanstack/react-query'
import { DashboardController } from 'src/controllers/dashboard.controller'
import { toast } from 'react-toastify'
import { DashboardDto } from 'src/dto/dashboard.dto'
import { useAuth } from 'src/contexts/auth'

const dashboardController = new DashboardController()

export function useGetDashboard() {
  const { userFarm: farmId } = useAuth()

  return useQuery<DashboardDto[], Error>({
    queryKey: ['dashboard', farmId],
    queryFn: () => dashboardController.getDashboardInfo(farmId!),
    enabled: !!farmId,
    throwOnError: () => {
      toast.error('Erro ao carregar o dashboard, tente novamente.')
      return false
    }
  })
}
